module.exports = __webpack_public_path__ + "h5/img/beian.d0289dc0.png";